import Vue from 'vue';
import VueRouter from 'vue-router';

const Homepage = () => import('./views/app/index.vue');

const Dashboard = () => import('./views/Dashboard/Index.vue');
const Profile = () => import('./views/Profile/Index.vue');

const Logout = () => import('./views/Logout.vue');

const ManagerLogin = () => import('./views/Manager/Auth/Login');
const ManagerForgotPassword = () => import('./views/Manager/Auth/Forgot');
const ManagerPasswordReset = () => import('./views/Manager/Auth/PasswordReset');

const UserLogin = () => import('./views/User/Auth/Login');
const UserForgotPassword = () => import('./views/User/Auth/Forgot');
const UserRegister = () => import('./views/User/Auth/Register');
const UserPasswordReset = () => import('./views/User/Auth/PasswordReset');

const TaxpayerRegister = () => import('./views/Taxpayer/Auth/Register.vue');
const TaxpayerLogin = () => import('./views/Taxpayer/Auth/Login.vue');
const TaxpayerForgotPassword = () => import('./views/Taxpayer/Auth/Forgot');
const TaxpayerPasswordReset = () => import('./views/Taxpayer/Auth/PasswordReset');

// Manager routes

const ManagerIndex = () => import('./views/Manager/Index.vue');
const ManagerShow = () => import('./views/Manager/Show.vue');
const ManagerCreate = () => import('./views/Manager/Create.vue');
const ManagerEdit = () => import('./views/Manager/Edit.vue');

const UsersIndex = () => import('./views/Users/Index.vue');
const UsersShow = () => import('./views/Users/Show.vue');
const UsersCreate = () => import('./views/Users/Create.vue');
const UsersEdit = () => import('./views/Users/Edit.vue');

// User routes

const UserDocumentsIndex = () => import('./views/UserDocuments/Index.vue');
const UserDocumentsSubmit = () => import('./views/UserDocuments/Submit.vue');
const UserDocumentsShow = () => import('./views/UserDocuments/Show.vue');
const UserDocumentsEdit = () => import('./views/UserDocuments/Edit.vue');

const TaxpayersIndex = () => import('./views/Taxpayers/Index.vue');
const TaxpayersShow = () => import('./views/Taxpayers/Show.vue');
const TaxpayersEdit = () => import('./views/Taxpayers/Edit.vue');
const TaxpayersCreate = () => import('./views/Taxpayers/Create.vue');

const UserTaxpayerDocumentsSubmit = () => import('./views/UserTaxpayerDocuments/Submit.vue');

// Taxpayer routes

const TaxpayerSettings = () => import('./views/Settings/Index.vue');

const TaxpayerDocumentsIndex = () => import('./views/TaxpayerDocuments/Index.vue');
const TaxpayerDocumentsShow = () => import('./views/TaxpayerDocuments/Show.vue');
const TaxpayerDocumentsEdit = () => import('./views/TaxpayerDocuments/Edit.vue');
const TaxpayerDocumentsSubmit = () => import('./views/TaxpayerDocuments/Submit.vue');

const NotFound = () => import('./views/app/404.vue');

import store from './store';
import NProgress from 'nprogress';

Vue.use(VueRouter);

let host = window.location.host;

const has_tenant_subdomain = host.split('.').length > 2;

const routes = [
  {
    path: '/',
    component: Homepage,
    redirect: { name: 'dashboard' },
    children: [
      { path: 'dashboard', component: Dashboard, name: 'dashboard' },
      { path: 'profile', component: Profile, name: 'profile' },

      // Manager routes

      { path: 'managers', component: ManagerIndex, name: 'managers.index' },
      { path: 'managers/create', component: ManagerCreate, name: 'managers.create' },
      { path: 'managers/:id', component: ManagerShow, name: 'managers.show' },
      { path: 'managers/:id/edit', component: ManagerEdit, name: 'managers.edit' },

      { path: 'users', component: UsersIndex, name: 'users.index' },
      { path: 'users/create', component: UsersCreate, name: 'users.create' },
      { path: 'users/:id', component: UsersShow, name: 'users.show' },
      { path: 'users/:id/edit', component: UsersEdit, name: 'users.edit' },

      // User routes

      { path: '/documents', component: UserDocumentsIndex, name: 'documents.index' },
      { path: '/documents/submit', component: UserDocumentsSubmit, name: 'documents.submit' },
      { path: '/documents/:id', component: UserDocumentsShow, name: 'documents.show' },
      { path: '/documents/:id/edit', component: UserDocumentsEdit, name: 'documents.edit' },

      { path: 'taxpayers', component: TaxpayersIndex, name: 'taxpayers.index' },
      { path: 'taxpayers/create', component: TaxpayersCreate, name: 'taxpayers.create' },
      { path: 'taxpayers/:id', component: TaxpayersShow, name: 'taxpayers.show' },
      { path: 'taxpayers/:id/edit', component: TaxpayersEdit, name: 'taxpayers.edit' },

      { path: '/documents/taxpayer-submit', component: UserTaxpayerDocumentsSubmit, name: 'user-taxpayer.documents.submit' },

      // Taxpayer routes

      { path: '/settings', component: TaxpayerSettings, name: 'settings', meta: { requiresAuth: true } },

      { path: 'taxpayer/documents', component: TaxpayerDocumentsIndex, name: 'taxpayer.documents.index' },
      { path: 'taxpayer/documents/submit', component: TaxpayerDocumentsSubmit, name: 'taxpayer.documents.submit' },
      { path: 'taxpayer/documents/:id', component: TaxpayerDocumentsShow, name: 'taxpayer.documents.show' },
      { path: 'taxpayer/documents/:id/edit', component: TaxpayerDocumentsEdit, name: 'taxpayer.documents.edit' },
    ],
  },
  {
    path: '/logout',
    component: Logout,
    name: 'logout',
  },

  ...(has_tenant_subdomain
    ? [
        {
          path: '/user/login',
          component: UserLogin,
          name: 'user.login',
        },
        {
          path: '/user/forgot',
          component: UserForgotPassword,
          name: 'user.forgot',
        },
        {
          path: '/user/password/reset/:token',
          component: UserPasswordReset,
          name: 'user.password.reset',
        },

        {
          path: '/taxpayer/register',
          component: TaxpayerRegister,
          name: 'taxpayer.register',
        },
        {
          path: '/taxpayer/login',
          component: TaxpayerLogin,
          name: 'taxpayer.login',
        },
        {
          path: '/taxpayer/forgot',
          component: TaxpayerForgotPassword,
          name: 'taxpayer.forgot',
        },
        {
          path: '/taxpayer/password/reset/:token',
          component: TaxpayerPasswordReset,
          name: 'taxpayer.password.reset',
        },
      ]
    : [
        {
          path: '/manager/login',
          component: ManagerLogin,
          name: 'manager.login',
        },
        {
          path: '/manager/forgot',
          component: ManagerForgotPassword,
          name: 'manager.forgot',
        },
        {
          path: '/manager/password/reset/:token',
          component: ManagerPasswordReset,
          name: 'manager.password.reset',
        },
        {
          path: '/user/register',
          component: UserRegister,
          name: 'user.register',
        },
      ]),

  {
    path: '*',
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'open',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.path) {
    NProgress.start();
    NProgress.set(0.1);
  }
  next();
});

router.afterEach(() => {
  const gullPreLoading = document.querySelector('#loading_wrap');
  if (gullPreLoading) gullPreLoading.style.display = 'none';
  setTimeout(() => NProgress.done(), 500);

  let isMobile = window.innerWidth <= 1200;
  if (isMobile) {
    store.dispatch('changeSidebarProperties');
    if (store.getters.getSideBarToggleProperties.isSecondarySideNavOpen) {
      store.dispatch('changeSecondarySidebarProperties');
    }
  } else {
    if (store.getters.getSideBarToggleProperties.isSecondarySideNavOpen) {
      store.dispatch('changeSecondarySidebarProperties');
    }
  }
});

export default router;
